import {createContext, useContext} from 'react';

export const ExternalizationContext = createContext();

export function useExternalizationContext() {
  return useContext(ExternalizationContext);
}